module Meevo.Plugins.IpRestrictions {
  "use strict";

  /**
  * Main Section of SecurityRole 
  */
  export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.IpRestriction> {

      createSectionModelInstance(postAdd: (data: any) => any): void {
          this.dataService.getItem(this.baseEndpoint, <any>this.identityService.current().locationId, " ")
              .then((data) => {
                  console.log("Data", data);
                  this.model = data;
                  
            });
    }
   
  }

}